import { BRACKETS, SYMBOL } from "../../helpers/constants";
import { MuiTypography } from "../typography/MuiTypography";
import { AmountWithSignWrapper } from "./AmountWithSign.style";

interface AmountWithSignProps {
  currency: string;
  sign: string;
}

export const AmountWithSign = ({ currency, sign }: AmountWithSignProps) => {
  return (
    <AmountWithSignWrapper>
      <MuiTypography variant="h3">
        {currency}
        <MuiTypography
          variant="h3Bold"
          className={sign === SYMBOL.PLUS ? "positive-sign" : "negative-sign"}
        >
          {`${BRACKETS.LEFT_SQUARE}${sign}${BRACKETS.RIGHT_SQUARE}`}
        </MuiTypography>
      </MuiTypography>
    </AmountWithSignWrapper>
  );
};
